<script setup lang="ts">
// this is a simplified copy of this https://github.com/storyblok/storyblok-vue/blob/main/lib/StoryblokComponent.vue
import { ref } from 'vue'
import { type SbBlokData } from './types'

type SbComponentProps = {
  blok: SbBlokData
}

const props = defineProps<SbComponentProps>()

const blokRef = ref()

const componentName = ref(props.blok.component)
</script>

<template>
  <component
    :is="componentName"
    ref="blokRef"
    v-bind="{ ...$props, ...$attrs }"
  />
</template>
